/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_NavInputs */

const en_mk_sol_startup_nav = /** @type {(inputs: Mk_Sol_Startup_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startups & product teams`)
};

const id_mk_sol_startup_nav = /** @type {(inputs: Mk_Sol_Startup_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startup & tim produk`)
};

/**
* | output |
* | --- |
* | "Startups & product teams" |
*
* @param {Mk_Sol_Startup_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_nav = /** @type {((inputs?: Mk_Sol_Startup_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_nav(inputs)
	return en_mk_sol_startup_nav(inputs)
});